module.exports = __webpack_public_path__ + "media/images/left_highlighted_arrow-a58b70680df890860da8ea65609c5693.png";